import Button from '../Button/Button';
import Modal from 'react-native-modal/dist/modal';
import React, { Fragment } from 'react';
import { FlatList, StyleSheet, TouchableOpacity, TouchableWithoutFeedback, View } from 'react-native';
import { NEUTRAL_TEXT500 } from '../../config/designSystem/Colors';
import { ParagraphMRegular } from '../../config/designSystem/typography';
import { ReactNode } from 'react';
import { isWeb } from '../../config/designSystem/Layout';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';
import { useSystemBottomInset } from '../../hooks/ui/useSystemBottomInset';



export interface itemOfModal {
    onPress?: () => void,
    label: string
    icon: ReactNode,
    modal?:(onDismiss : () => void) => ReactNode,
    dismissOnPress: boolean
}

interface ModalBelowProps {
    isVisible: boolean;
    onDismiss: () => void;
    items: Array<itemOfModal>;
    labelBelow: string;
  }


export const ModalBelow = ({ isVisible, onDismiss, items, labelBelow}: ModalBelowProps) => {
  const {width, height} = useAvailableDimensions();
  // A native <Modal> renders in its own window, outside the root view that reserves the
  // Android navigation-bar inset for the rest of the app, so this sheet has to do it
  // itself -- otherwise its bottom button is drawn behind the navigation bar.
  const systemBottomInset = useSystemBottomInset();
  const BORDER_RADIUS = 20;
  const MARGIN_HORIZONTAL=20;
  const WIDTH = Math.min(600, width-2*MARGIN_HORIZONTAL);
  const [mainModalVisible, setMainModalVisible] = React.useState<boolean>(true);
  const [isVisibleArray, setIsVisibleArray] = React.useState<boolean[]>(Array(items?.length).fill(false));
  const [indexSubModal, setIndexSubModal] = React.useState<number>(-1);


  const onDismissModal= (index : number) => {
    setIsVisibleArray(isVisibleArray.map((visible,idx) => {
      if(idx === index) {
        return false;
      } else {
        return visible;
      }
    }));
  };




  const onShowModal = (index: number) => {
    setIsVisibleArray(isVisibleArray.map((visible,idx) => {
      if(idx === index) {
        return true;
      } else {
        return visible;
      }
    }));
  };



  React.useEffect(() => {
    if(!isVisible) {
      setMainModalVisible(true);

    }
  }, [isVisible]);

  React.useEffect(() => {
    setIsVisibleArray(Array(items?.length).fill(false));
    setIndexSubModal(-1);
  }, [items]);





  const onDismissWrapper= (index : number) => {
    onDismissModal(index);
    onDismiss();
  };

  const modalWrapper = (index: number) => {
    const dismissModal = () =>  onDismissWrapper(index);
    if(items[index].modal) {
      return (
        <Modal
          isVisible={isVisibleArray[index]}
          onBackButtonPress={dismissModal}
          onBackdropPress={dismissModal}

        >

          {items[index].modal(dismissModal)}
        </Modal>);
    } else {
      return null;
    }
  };

  const optionModals = () => {
    return (
      <>
        {items.map((_item,idx) => {
          return(<>
            {modalWrapper(idx)}
          </>);
        })}
      </>);
  };

  const simpleOption = ({item, index} : {item:itemOfModal, index: number}) => {
    return (
      <Fragment key={index}>
        <TouchableOpacity
          onPress={() => {
            if(item.onPress) {
              item.onPress();
            }
            if(item.modal) {
              setMainModalVisible(false);
              setIndexSubModal(index);
            } else if(item.dismissOnPress) {
              onDismiss();
            }

          }}
          style= {{flexDirection:'row', marginBottom: 40, flex:1}}
        >
          <View style={{width: 20, marginRight:20}}>
            {item.icon}
          </View>
          <ParagraphMRegular
            color={NEUTRAL_TEXT500}
          >
            {item.label}
          </ParagraphMRegular>

        </TouchableOpacity>
      </Fragment>
    );
  };

  const renderOptions= () => {
    return (<FlatList data={items} renderItem={simpleOption} />);
  };

  const modal= () => {
    return(
      <View>
        {renderOptions()}
        <Button color='white' onPress={onDismiss} label={labelBelow} width={WIDTH} marginHorizontal={0}/>
      </View>
    );
  };

  const mainModalWrapper = () => {
    const belowMargin = isWeb? height/3:0;
    const belowRadius = isWeb? BORDER_RADIUS: 0;
    return (
      <Modal
        isVisible={mainModalVisible}
        style={{
          backgroundColor: 'white',
          margin:0,
          borderTopLeftRadius: BORDER_RADIUS,
          borderTopRightRadius:BORDER_RADIUS,
          borderBottomLeftRadius: belowRadius,
          borderBottomRightRadius: belowRadius,
          position:'absolute',
          bottom:belowMargin,
          alignSelf:'center',
          paddingHorizontal:MARGIN_HORIZONTAL,
          paddingBottom: 10 + systemBottomInset,
          paddingTop:30 }}
        onBackButtonPress={() => { onDismiss(); }}
        onBackdropPress={()=> {onDismiss();}}
        onModalHide={() => {
          if(indexSubModal !== -1) {
            onShowModal(indexSubModal);
            setIndexSubModal(-1);
          }
        }}
      >

        <TouchableWithoutFeedback onPressOut={() => { onDismiss(); }}>
          {  <View
            style={{ flex: 1}}
          >
            <View style={styles.centeredView}>
              <TouchableWithoutFeedback>
                {modal()}
              </TouchableWithoutFeedback>
            </View>
          </View>}
        </TouchableWithoutFeedback>
      </Modal>);
  };


  return (<>
    {isVisible && (
      <>
        {optionModals()}
        {mainModalWrapper()}
      </>
    )}
  </>);
};

const styles = StyleSheet.create  ({
  centeredView: {
    justifyContent:'center',
    alignItems: 'center',
    flex:1
  }
});
